<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <div class="d-flex align-items-center justify-content-between mb-3 mt-3">
        <b-button variant="secondary" class="ml-2" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
        </b-button>
        <div class="d-flex" style="gap:8px;">
          <b-button v-if="editMode && puedeEditar" @click.prevent="submitForm" variant="primary">
            <i class="fas fa-save mr-1"></i> {{ $t('guardar') }}
          </b-button>
          <!-- Sin permiso de edición la pantalla queda en modo consulta. -->
          <base-button v-if="puedeEditar" :type="editMode ? 'danger' : 'warning'" @click="cancelEdit">
            {{ editMode ? $t('cancelar') : $t('editar') }}
          </base-button>
        </div>
      </div>

      <b-container style="max-width: 90%; margin: auto;">

        <b-card-header class="border-0">
          <h3 class="mb-0">{{ $t('informacion') }}</h3>
        </b-card-header>
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="3">
              <b-form-group :label="$t('fecha')" label-for="fecha">
                <!-- La fecha es la clave del registro, no se edita. -->
                <b-form-input id="fecha" type="date" :value="fechaClave" disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <h4 class="text-white mt-2 mb-2">{{ $t('paridades_clp') }}</h4>
          <b-row>
            <b-col md="2" v-for="col in obligatorias" :key="col.key">
              <b-form-group :label-for="col.key">
                <template v-slot:label>
                  {{ col.label }} <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" :id="col.key" type="number" step="0.000001" min="0"
                  v-model="tipoCambio[col.key]" required :placeholder="col.label"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <h4 class="text-white mt-2 mb-2">{{ $t('paridades_cruzadas') }}</h4>
          <b-row>
            <b-col md="2" v-for="col in opcionales" :key="col.key">
              <b-form-group :label="col.label" :label-for="col.key">
                <b-form-input :disabled="!editMode" :id="col.key" type="number" step="0.000001" min="0"
                  v-model="tipoCambio[col.key]" :placeholder="col.label"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button v-if="editMode && puedeEditar" type="submit" variant="primary" class="ml-3">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import tipoCambioService from '@/api/tipoCambioService';
import utilsService from '@/api/utilsService';
import Swal from 'sweetalert2';

export default {
  name: 'TipoCambioDetalle',
  data() {
    return {
      tipoCambio: {},
      editMode: false,
      obligatorias: [
        { key: 'usdClp', label: 'USD/CLP' },
        { key: 'eurClp', label: 'EUR/CLP' },
        { key: 'arsClp', label: 'ARS/CLP' },
        { key: 'copClp', label: 'COP/CLP' },
        { key: 'penClp', label: 'PEN/CLP' },
        { key: 'audClp', label: 'AUD/CLP' },
      ],
      opcionales: [
        { key: 'usdArs', label: 'USD/ARS' },
        { key: 'usdCop', label: 'USD/COP' },
        { key: 'usdPen', label: 'USD/PEN' },
        { key: 'audUsd', label: 'AUD/USD' },
        { key: 'eurUsd', label: 'EUR/USD' },
      ],
    };
  },
  computed: {
    puedeEditar() {
      return utilsService.puedeEscribir() && utilsService.getRol() !== 'ventas inex';
    },
    fechaClave() {
      return String(this.$route.params.fecha || '').substring(0, 10);
    },
  },
  async beforeMount() {
    this.tipoCambio = await tipoCambioService.get(this.fechaClave);
  },
  methods: {
    async cancelEdit() {
      if (this.editMode) {
        this.tipoCambio = await tipoCambioService.get(this.fechaClave);
      }
      this.editMode = !this.editMode;
    },
    submitForm() {
      if (!this.puedeEditar) return;
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('revisa_datos'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('actualizar'),
        cancelButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                    '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                    '<div><h3 style="color:#006393;">' + this.$t('actualizando') + '</h3></div>' +
                    '</div>',
              showConfirmButton: false,
              allowOutsideClick: false,
            });

            const response = await tipoCambioService.update(this.tipoCambio, this.fechaClave);
            if (!response) {
              Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error inesperado.' });
              return;
            }

            Swal.fire({
              title: this.$t('actualizado_correctamente'),
              icon: 'success',
              showConfirmButton: false,
              timer: 2000,
            });
            this.editMode = false;
            this.tipoCambio = await tipoCambioService.get(this.fechaClave);
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: (error && error.message) ? error.message : 'Ocurrió un error inesperado.',
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    },
  },
};
</script>
